import React from 'react';
import classNames from 'classnames';
import './SearchButton.css';


export const SearchButton = ({onClick, classname, disabled=false}) => {
    return <button className={classNames("search_button", "searchBtn", classname !== undefined ? classname : '')} onClick={onClick} disabled={disabled}></button>;
}